import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import { BrowserRouter as Router } from 'react-router-dom'

import { LaunchDarkly, Spinner } from '@atheneum/ui-components'
import { createLDReactProvider, useInitializationStatus, useLDClient } from '@launchdarkly/react-sdk'

import App from './App'
import { stores } from '@stores'

import 'sweetalert2/dist/sweetalert2.css'
import './reset.sass'
import './App.sass'

// Set application name BEFORE importing App
LaunchDarkly.setApplicationName('client-km-interface-ui')

function LaunchDarklyBridge({ children }) {
  const ldClient = useLDClient()
  const { status } = useInitializationStatus()

  React.useEffect(() => {
    if (ldClient) {
      LaunchDarkly.setLDClient(ldClient)
    }
  }, [ldClient])

  if (status === 'initializing') {
    return <Spinner />
  }

  return children
}

;(async () => {
  const baseURL = process.env.REACT_APP_LAUNCH_DARKLY_BASE_URL
  const streamURL = process.env.REACT_APP_LAUNCH_DARKLY_STREAM_URL
  const eventsURL = process.env.REACT_APP_LAUNCH_DARKLY_EVENTS_URL
  const clientID = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID

  const LDProvider = createLDReactProvider(clientID, LaunchDarkly.getLDContext(), {
    ldOptions: {
      applicationInfo: { id: LaunchDarkly.getApplicationName() },
      ...(baseURL && { baseUri: baseURL }),
      ...(streamURL && { streamUri: streamURL }),
      ...(eventsURL && { eventsUri: eventsURL }),
    },
  })

  ReactDOM.render(
    <LDProvider>
      <LaunchDarklyBridge>
        <Provider {...stores}>
          <Router>
            <App />
          </Router>
        </Provider>
      </LaunchDarklyBridge>
    </LDProvider>,
    document.getElementById('root'),
  )
})()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
